import { faInfoCircle } from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const urlParcoursAdmission = process.env.REACT_APP_URL_PARCOURS_ADMISSION;

const DateTest = ({ handleChange, values, dates, handleErreur }) => {

    const message = "De nouvelles dates seront bientôt disponibles.";

    const datesFiltrees = () => {
        if (!Array.isArray(dates)) return [];

        // On convertit la modalité en nombre pour éviter les soucis de string
        const modaliteSuivi = Number(values.idModaliteSuivi);

        return dates.filter((date) => {
            const estPresentiel = Boolean(date.presentiel);
            const estDistanciel = Boolean(date.distanciel);

            // --- Conditions ---
            const conditionPresentiel =
                estPresentiel && modaliteSuivi === 121581; // Présentiel

            const conditionDistanciel =
                estDistanciel && modaliteSuivi === 121584; // En ligne

            const conditionSansChoix =
                (modaliteSuivi === 0 /*non sélectionné*/ || modaliteSuivi === 121604 /*Je ne sais pas*/);


            return (
                date.id > 0 &&
                (conditionPresentiel ||
                    conditionDistanciel ||
                    conditionSansChoix)
            )
        });
    };

    const getNombreDatesDispo = () => {
        var nombre = datesFiltrees()?.length;
        return nombre === undefined ? 0 : nombre;
    }
    const getDate = () => {
        return datesFiltrees()
            .map((date) => {
                return <option key={date} value={date.id}>{date.libelle} </option>
            });
    }

    if (values.idFormation > 0 && getNombreDatesDispo() > 0) {
        return (
            <div class="d-flex flex-column mt-sm-0 mt-4">
                <label>Sélectionnez votre journée d'informations ?* <a target="_blank" rel="noopener noreferrer"  href={urlParcoursAdmission}><FontAwesomeIcon color='gray' icon={faInfoCircle} /></a></label>
                <select
                    type="text"
                    value={values.idJourneeTest}
                    onChange={handleChange("idJourneeTest")}
                    id="idJourneeTest"
                >
                    <option value="0" selected="selected"></option>
                    {getDate()}
                </select>
                {handleErreur("idJourneeTest")}
            </div>
        )
    }
    else if (values.idFormation > 0) {
        return (<div class="d-flex flex-column">
            <label>Sélectionnez votre journée d'informations ?*</label>
            <div>{message}</div>
        </div>)
    }
    else {
        return <></>
    }
}

export default DateTest